import type { FunctionComponent, SVGProps } from "react";
import { IconButton as MuiIconButton, styled } from "@mui/material";
import { keyframes } from "@emotion/react";
import { base, focus } from "@constants/colors";

type SvgIcon = FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;

interface Props {
  Icon: SvgIcon;
  size: string;
}

const enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
`;

const StyledButton = styled(MuiIconButton)`
  && .MuiTouchRipple-child {
    background-color: ${focus.accentForegroundFocus};
  }
  && .MuiTouchRipple-rippleVisible {
    opacity: 0.5;
    animation-name: ${enterKeyframe};
    animation-duration: 550ms;
    animation-timing-function: ${({ theme }) => theme.transitions.easing.easeInOut};
  }

  > svg {
    transition: all 1s ease;
  }
  :hover {
    > svg {
      fill: ${base.accentForeground};
    }
  }
`;

export const IconButton = ({ Icon, size }: Props) => {
  return (
    <StyledButton>
      <Icon height={size} width={size} />
    </StyledButton>
  );
};
